<template>
  <div class="project-statistics">
    <div class="spinner-wrapper">
      <loading></loading>
    </div>
    <div class="statistics-global">
      <div class="panel-container panel-container--mobile">
        <div class="panel bk-sent">
          <bk-sent v-if="!is_loading" :statistics="statistics"/>
        </div>
        <div class="panel leads-chart">
          <leads-chart v-if="!is_loading" :start-date="queryParams.start_date" :end-date="queryParams.end_date" :leads-count="leads_count" :statistics="statistics" :trackings="trackings"/>
        </div>
        <div class="panel leads-classification">
          <leads-classification v-if="!is_loading" :statistics="statistics"/>
        </div>
        <div class="panel bk-per-lead">
          <bk-per-lead v-if="!is_loading" :statistics="statistics"/>
        </div>
      </div>
      <div class="panel-container panel-container--desktop">
        <div class="column column-left">
          <div class="panel bk-sent">
            <bk-sent v-if="!is_loading" :statistics="statistics"/>
          </div>
          <div class="panel leads-chart">
            <leads-chart v-if="!is_loading" :start-date="queryParams.start_date" :end-date="queryParams.end_date" :leads-count="leads_count" :statistics="statistics" :trackings="trackings"/>
          </div>
        </div>
        <div class="column column-right">
          <div class="panel leads-classification">
            <leads-classification v-if="!is_loading" :statistics="statistics"/>
          </div>
          <div class="panel bk-per-lead">
            <bk-per-lead v-if="!is_loading" :statistics="statistics"/>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!is_loading" class="grid title-grid">
      <h3>{{$t('statistics.latest_trackings')}}</h3>
      <router-link class="link full-link" :to="{name: 'project_statistics_trackings', params: { id: id }}">
        {{$t('statistics.see_full_tracking_history')}}
      </router-link>
      <router-link class="icon yule-icon-chevron-right link short-link" :to="{name: 'project_statistics_trackings', params: { id: id }}">
      </router-link>
    </div>
    <div class="statistics-trackings" v-if="trackings">
      <tracking-table v-if="!is_loading" date-format="DD.MM.YYYY HH:mm" :project-id="id" :trackings="trackings.resources"/>
    </div>
    <div v-else class="is-empty">
      {{$t('statistics.no_data')}}
    </div>
    <div class="statistics-ranking" v-if="rankings && ranking_unable">
      <h3 v-if="!is_loading">{{$t('statistics.lead_detectors_overview')}}</h3>
      <ranking v-if="!is_loading" :rankings="rankings"></ranking>
    </div>
  </div>
</template>
<script>
import Tracking from '@/api/Tracking'
import Statistic from '@/api/Statistic'

import Gauge from '@/components/helpers/DataDisplay/Gauge'
import Project from "@/api/Project"
import ProjectStatisticsBkPerLead from './ProjectStatisticsBkPerLead'
import ProjectStatisticsBkSent from './ProjectStatisticsBkSent'
import ProjectStatisticsLeadsChart from './ProjectStatisticsLeadsChart'
import ProjectStatisticsLeadsClassification from './ProjectStatisticsLeadsClassification'
import ProjectStatisticsRanking from './ProjectStatisticsRanking'
import RelativeDateChoser from '@/components/helpers/DataInput/RelativeDateChoser'
import Loading from '@/components/helpers/Specific/Loading.vue'

import TrackingTable from './TrackingTable'
import { mapGetters } from 'vuex'
import Ui from '@/classes/Ui'

export default {
  props: ['id'],
  components: {
    Gauge,
    Loading,
    TrackingTable,
    RelativeDateChoser,
    'ranking': ProjectStatisticsRanking,
    'bk-per-lead': ProjectStatisticsBkPerLead,
    'bk-sent': ProjectStatisticsBkSent,
    'leads-chart': ProjectStatisticsLeadsChart,
    'leads-classification': ProjectStatisticsLeadsClassification,
  },
  computed: {
    ranking_unable(){
      return (this.$store.getters.getOrganizationConfig('ranking_display') == 'true')
    }
  },
  data(){
    return {
      projectNavigation: [
        { name: "project_leads", action: "project_leads.list", redential: "project_leads.list"},
        { name: "project_statistics", action: "project_leads.statistics", credential: "projects.statistics", access: "allowed_statistics" },
        { name: "project_edit", action: "project.edit", credential: "projects.update" },
        { name: "project_assignments_edit", action: "project_assignments.edit", credential: "projects.update" }
      ],
      is_loading: true,
      project_api: new Project(),
      project: null,
      statistics_api: new Statistic(),
      statistics: [],
      trackings: {},
      rankings: [],
      leads_count: {},
      queryParams: {
        sort_by: 'time',
        sort_order: 'DESC'
      }
    }
  },
  mounted(){
    this.dateChange(1)
    Ui.setSecondaryHeaderTabs(this.projectNavigation)
  },
  beforeDestroy() {
    this.$store.commit('SET_SECONDARY_HEADER_TABS', [])
  },
  methods: {
    afterRetrieve(){
      Ui.setPageLevel("3")
      Ui.setPageType(this.singular_model)
      Ui.setSubtitle({link: {name: "projects"}})
      Ui.setTitle({ label: this.project.name })
      Ui.clearHeaderButtons()
      this.$store.commit('SET_PAGE_TYPE', 'project_lead')
    },
    async dateChange(number){
      this.is_loading = true
      this.queryParams.start_date = moment().subtract(60,'d').format()
      this.queryParams.end_date = moment().format()
      this.statistics = []
      this.trackings = {}
      this.rankings = []
      this.leads_count ={}
      this.project = await this.retrieveProject()
      this.statistics = await this.retrieveStatistics()
      this.leads_count = await this.retrieveStatisticsLeadsCount()
      this.trackings = await this.retrieveTrackings()
      this.rankings = await this.retrieveRankings()
      this.afterRetrieve()
      this.is_loading = false
    },
    async retrieveProject(){
     return await this.project_api.show(this.id)
    },
    async retrieveStatistics(){
      this.queryParams.params = {
        start_date: this.queryParams.start_date,
        end_date: this.queryParams.end_date,
      }
      try {
        return await this.project_api.statistics(this.id, this.queryParams)
      } catch (err) {
        console.warn(err)
      }
    },
    async retrieveStatisticsLeadsCount(){
      try {
        return await this.project_api.statistics_leads_count(this.id, this.queryParams)
      } catch (err) {
        console.warn(err)
      }
    },
    async retrieveTrackings(){
      let params = Object.assign(this.queryParams, {project_id: this.id})
      let tracking = new Tracking()
      try {
        return await tracking.all(params)
      } catch (err) {
        console.warn(err)
      }
    },
    async retrieveRankings(){
      try {
        return await this.statistics_api.userRankings(this.id, this.queryParams)
      } catch (err) {
        console.warn(err)
      }
    }
  }
}
</script>
<style lang="scss">
.project-statistics{
  a{
    color: #2e7bae;
  }
  h3{
    font-weight: 400;
    margin: 0 0 1em;
    color: $onyx;
    font-size: 2em;
  }
  .is-empty{
    margin-bottom: 20px;
  }
  .statistics-loader{
    text-align: center;
    display: flex;
    justify-content: center;

  }
  @include respond-to("medium"){
    h3{
      margin-bottom: 20px;
    }
    .grid{
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  .title-grid{
    align-items: center;
    margin-bottom: 10px;
    .link{
      text-align: right;
      text-decoration: none;
    }
    .short-link{
      display: none;
    }
    .icon{
      font-size: 26px;
      vertical-align: sub;
    }
    h3{
      margin-bottom: 0;
    }
    @include respond-to("medium"){
      justify-content: space-between;
      .short-link{display: inline;}
      .full-link{display: none;}
    }
  }

}

.statistics-global,
.statistics-trackings,
.statistics-ranking{
  margin-bottom: 40px;
}

.panel-container{
  display: flex;


  @include respond-to("medium"){
    flex-direction: column;
  }
  @include respond-to("medium-up"){
    flex-direction: row;
    flex-wrap: wrap;
  }
  @include respond-to("large-up"){
    flex-direction: row;
    flex-wrap: wrap;
    .column-left{
      flex-grow: 7;
      flex-shrink: 0;
      flex-basis: 65%;
    }
    .column-right{
      flex-grow: 3;
      flex-shrink: 0;
      flex-basis: 35%;
    }
  }

}

.panel-container.panel-container--mobile{
  @include respond-to("large-up"){
    display: none;
  }
  @include respond-to("large"){
    display: flex;
  }
}
.panel-container.panel-container--desktop{
  @include respond-to("large"){
    display: none;
  }
  @include respond-to("large-up"){
    display: flex;
  }
}

.panel{
  width: 100%;
  padding: 10px;
  .card{
    margin:0;
    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.18);
    .card--content{
      padding: 10px;
    }
    hr{
      border: none;
      height: 1px;
      background: #eaeaea;
      margin-left: -10px;
      margin-right: -10px;
    }
  }
  @include respond-to("medium"){
    text-align: center;
    margin-bottom: 30px;
    .card--number{
      margin-top: 30px;
    }
  }
  @include respond-to("medium"){
    padding: 0;
    margin-bottom: 20px;
    hr{
      margin-left: 0;
      margin-right: 0;
    }
    .card{
      box-shadow: none;
      .card--content{
        padding: 0;
      }
    }
  }
  @include respond-to("medium-up"){
    &.leads-classification,
    &.bk-per-lead{
      width: 50%;
    }
    &.leads-classification{
      order: 4
    }
    &.bk-per-lead{
      order: 3
    }
    &.bk-sent,
    &.leads-chart{
      padding-left: 0;
      padding-right: 0;
    }
    &.bk-per-lead{
      padding-left: 0;
    }
    &.leads-classification{
      padding-right: 0;
    }
  }
  @include respond-to("large-up"){
    &.bk-sent{
      order: 1;
      width: 100%;
      padding-right: 10px;
    }
    &.leads-chart{
      order: 3;
      width: 100%;
      padding-right: 10px;
    }
    &.leads-classification{
      order: 4;
      width: 100%;
    }
    &.bk-per-lead{
      order: 2;
      width: 100%;
      padding-left: 10px;
      padding-right: 0;
    }
  }
}

.card--number{
  text-align: center;
  margin: 15px 0;
  .card--number-value{
    font-size: 64px;
    line-height: 64px;
    font-weight: 400;
  }
  .card--number-key{
    font-size: 18px;
    font-weight: 400;
  }
}
@keyframes rotate {
  100% {
    transform: rotate(-360deg);
  }
}
</style>



// WEBPACK FOOTER //
// ProjectStatistics.vue?e31827c4